import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TabViewModule } from 'primeng/tabview';
import { MessageModule } from 'primeng/message';
import { ActivationStatus, Currency, CustomerActivationRequest, InitiateSessionResponse, PaymentDetails } from '../general.model';
import { TransactionService } from '../transaction/transaction.service';
import { InstantBankTransferService } from '../instant-bank-transfer.service';
import { AuthService } from '../transaction/auth.service';

interface CountryOption {
  label: string;
  value: string;
  flag: string;
  currency?: string;
}


@Component({
  selector: 'app-receive-money-abroad',
  standalone: true,
  imports: [MessageModule,SelectModule,CommonModule, TabViewModule, ButtonModule, RadioButtonModule, FormsModule, DropdownModule],
  templateUrl: './receive-money-abroad.component.html',
  styleUrl: './receive-money-abroad.component.css'
})
export class ReceiveMoneyAbroadComponent {
  
  selectedMethod: 'card' | 'bank' = 'bank';

  dropdownOpen = false;

  countries: CountryOption[] = [
    {
      label: 'Austria',
      value: 'AUT',
      flag: 'fi fi-at',
      currency: 'EUR'
    },
    {
      label: 'Belgium',
      value: 'BEL',
      flag: 'fi fi-be',
      currency: 'EUR'
    },
    {
      label: 'Estonia',
      value: 'EST',
      flag: 'fi fi-ee',
      currency: 'EUR'
    },
    {
      label: 'Finland',
      value: 'FIN',
      flag: 'fi fi-fi',
      currency: 'EUR'
    }
    ,
    {
      label: 'France',
      value: 'FRA',
      flag: 'fi fi-fr',
      currency: 'EUR'
    },
    {
      label: 'Germany',
      value: 'DEU',
      flag: 'fi fi-de',
      currency: 'EUR'
    },
    {
      label: 'Ireland',
      value: 'IRL',
      flag: 'fi fi-ie',
      currency: 'EUR'
    },
    {
      label: 'Italy',
      value: 'ITA',
      flag: 'fi fi-it',
      currency: 'EUR'
    },
    {
      label: 'Latvia',
      value: 'LVA',
      flag: 'fi fi-lv',
      currency: 'EUR'
    },
    {
      label: 'Lithuania',
      value: 'LTU',
      flag: 'fi fi-lt',
      currency: 'EUR'
    },
    {
      label: 'Netherlands',
      value: 'NLD',
      flag: 'fi fi-nl',
      currency: 'EUR'
    },
    {
      label: 'Portugal',
      value: 'PRT',
      flag: 'fi fi-pt',
      currency: 'EUR'
    },
    {
      label: 'Slovakia',
      value: 'SVK',
      flag: 'fi fi-sk',
      currency: 'EUR'
    },
    {
      label: 'Slovenia',
      value: 'SVN',
      flag: 'fi fi-si',
      currency: 'EUR'
    },
    {
      label: 'Spain',
      value: 'ESP',
      flag: 'fi fi-es',
      currency: 'EUR'
    },
    {
      label: 'United Kingdom',
      value: 'GBR',
      flag: 'fi fi-gb',
      currency: 'GBP'
    }
  ];

  constructor(private router: Router,
    private transactionService:TransactionService,
    private instantBankTransferService:InstantBankTransferService,
    private authService:AuthService ) {    

  }

  selectedCountry: CountryOption | null = null;

  showMessage:boolean=false;

  toggleDropdown(): void {
    this.dropdownOpen = !this.dropdownOpen;
  }

  selectCountry(country: CountryOption): void {
    this.selectedCountry = country;
    this.dropdownOpen = false; // this closes the dropdown after selection
    let paymentDetails:PaymentDetails = this.instantBankTransferService.data();
    
    if (paymentDetails) {
      //paymentDetails.bankLocation = country.label;
      let countryOption:CountryOption|undefined = this.countries.find(c => c.value === country.value);
      paymentDetails.currency = countryOption?.currency as Currency || 'DEFAULT_CURRENCY';
      paymentDetails.sourceCurrency = countryOption?.currency as Currency || 'DEFAULT_CURRENCY';
      paymentDetails.bankLocation = country.value;
    }
    this.instantBankTransferService.data.set(paymentDetails);
  }
  
  countryOption:CountryOption|undefined;
  onclick(){
    let activationId : string="";
    this.router.navigate(['/amount']) ;

    /*let customerActivationRequest: CustomerActivationRequest = {
      preferredCurrency: this.instantBankTransferService.data().sourceCurrency,
      countryOfResidence: this.instantBankTransferService.data()?.bankLocation || '',
      country: 'UGA'
    };
    let correlationId:string=this.authService.uuid()??'';
    this.transactionService.initiateActivate(customerActivationRequest,correlationId).subscribe({
        next: (response) => {
            let activationStatus: ActivationStatus = response;
            //this.authService.setDiasporaSessionToken(initiateSessionResponse.diasporaSessionToken);
            //activationStatus === ActivationStatus.ACTIVE ? this.router.navigate(['/amount']) : this.router.navigate(['/activate']);
            this.router.navigate(['/amount']) ;

            console.log('Data received:', response);
        },
        error: (err) => {
          this.router.navigate(['/service-unavailable']) ;
            console.error('Error occurred:', err);
        }
    });*/

  }

  openMessage() {
    this.showMessage = !this.showMessage;
  }

  /*initiate(userId: string) {
    this.transactionService.activateStatus(userId).subscribe({
          next: (response) => {
              let initiateSessionResponse: InitiateSessionResponse = response;
              let status:string = response;
            
              //this.authService.setDiasporaSessionToken(initiateSessionResponse.diasporaSessionToken);
              console.log('Data received:', response);
          },
          error: (err) => {
              console.error('Error occurred:', err);
          }
      });
  }*/

    
}
